export const ActionTypes = {
  LOADING: "DELETE_VALUES_LOADING",
  ERROR: "DELETE_VALUES_ERROR",
  SUCCESS: "DELETE_VALUES_SUCCESS",
};
